import { memo } from 'react';
import { useTranslation } from 'src/hooks/use-translation';
import Stack from '@mui/material/Stack';

import { NavGroupProps, NavProps } from '../types';

import { NavList } from './nav-list';

const NavSectionMini = memo(({ data, slotProps, ...other }: NavProps) => {
  const { t } = useTranslation('', { keyPrefix: 'sidebar' });

  return (
    <Stack
      component="nav"
      id="nav-section-mini"
      aria-label={t('navigation')}
      spacing={`${slotProps?.gap || 4}px`}
      {...other}
    >
      {data.map((group, index) => (
        <Group key={group.subheader || index} items={group.items} slotProps={slotProps} />
      ))}
    </Stack>
  );
});

NavSectionMini.displayName = 'NavSectionMini';

export { NavSectionMini };

// ----------------------------------------------------------------------

function Group({ items, slotProps }: NavGroupProps) {
  return (
    <>
      {items.map((list) => (
        <NavList key={list.title} data={list} depth={1} slotProps={slotProps} />
      ))}
    </>
  );
}
